import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import type { ExternalChatConfig, ExternalChatConfigResponse } from './types';

interface GetConfigResponse {
  data?: ExternalChatConfigResponse;
  detail?: string;
}

interface UpdateConfigResponse {
  data?: { status: string };
  detail?: string;
}

export const getExternalChatConfig = async (
  collectionId: string,
): Promise<GetConfigResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<ExternalChatConfigResponse>({
    url: `/${orgId}/collections/${collectionId}/external-chat/config`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to get external chat config',
    };
  }

  return response as GetConfigResponse;
};

export const updateExternalChatConfig = async (
  collectionId: string,
  config: Partial<ExternalChatConfig>,
): Promise<UpdateConfigResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<{ status: string }>({
    url: `/${orgId}/collections/${collectionId}/external-chat/config`,
    method: 'PATCH',
    body: config as Record<string, unknown>,
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to update external chat config',
    };
  }

  return response as UpdateConfigResponse;
};
